/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserAuthRequestDto
 */
export interface UserAuthRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserAuthRequestDto
   */
  email: string;
}

export function UserAuthRequestDtoFromJSON(json: any): UserAuthRequestDto {
  return UserAuthRequestDtoFromJSONTyped(json, false);
}

export function UserAuthRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAuthRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json["email"],
  };
}

export function UserAuthRequestDtoToJSON(value?: UserAuthRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
  };
}
